if (!("ontouchstart" in window)) {


setTimeout(() => {
  document.querySelectorAll(".indiv-product").forEach((product) => {
		let preventDistortion = product.classList.contains('preventDistortion');
    const productImage = product.querySelector(
      ".collection-image-anim .grid__image"
    );

    const animations = [
      (img) => {
        // Scaling Animation
        let scale = 1;
        let growing = true;
        let frame;

        const grow = () => {
          if (growing) {
            scale += 0.003; // Adjust speed
            img.style.transform = `scale(${scale})`;
            img.style.zIndex = "1000";
            img.style.position = "relative";
            img.style.display = "block";
            img.style.pointerEvents = "none";
            frame = requestAnimationFrame(grow);
          }
        };

        product.addEventListener("mouseleave", () => {
          growing = false;
          cancelAnimationFrame(frame);
          img.style.transform = "scale(1)";
          img.style.zIndex = "1";
        });

        product.addEventListener("blur", () => {
          growing = false;
          cancelAnimationFrame(frame);
          img.style.transform = "scale(1)";
          img.style.zIndex = "1";
        });

        grow();
      },

      (img) => {
        // Spinning Animation
        let angle = 0;
        let direction = Math.random() > 0.5 ? -1 : 1;
        let spinning = true;
        let frame;

        const spin = () => {
          if (spinning) {
            angle += direction;
            img.style.transform = `rotate(${angle}deg)`;
            img.style.zIndex = "1000";
            img.style.position = "relative";
            img.style.display = "block";
            img.style.pointerEvents = "none";
            frame = requestAnimationFrame(spin);
          }
        };

        product.addEventListener("mouseleave", () => {
          spinning = false;
          cancelAnimationFrame(frame);
          img.style.transform = "rotate(0deg)";
          img.style.zIndex = "1";
        });

        product.addEventListener("blur", () => {
          spinning = false;
          cancelAnimationFrame(frame);
          img.style.transform = "rotate(0deg)";
          img.style.zIndex = "1";
        });

        spin();
      },

      // TURNED OFF BY REQUEST OF NEW MUSEUM
      // (img) => {
      //   // Fly Away Animation with requestAnimationFrame
      //   // reconstructed
      //   const clones = [];
      //   const cloneContainer = document.createElement("div");
      //   cloneContainer.classList.add("clone-container")
      //   cloneContainer.style.position = "absolute";
      //   cloneContainer.style.top = "0";
      //   cloneContainer.style.left = "0";
      //   cloneContainer.style.width = "100%";
      //   cloneContainer.style.height = "100%";
      //   cloneContainer.style.pointerEvents = "none";
      //   // cloneContainer.style.zIndex = "100"
      //   img.parentElement.appendChild(cloneContainer);

      //   for (let i = 0; i < 5; i++) {
      //     const clone = img.cloneNode(true);
      //     clone.style.position = "absolute";
      //     clone.style.zIndex = "100";
      //     clone.style.left = img.offsetLeft + "px";
      //     clone.style.top = img.offsetTop + "px";
      //     clone.style.width = img.offsetWidth + "px";
      //     clone.style.height = img.offsetHeight + "px";
      //     // clone.style.transition = "opacity 0.5s ease-out";
      //     clone.style.pointerEvents = "none";
      //     cloneContainer.appendChild(clone);
      //     clones.push({
      //       element: clone,
      //       angle: (Math.PI * 2 * i) / 5, // Spread clones in different directions
      //       speed: Math.random() * 4 + 10, // Random speed
      //       distance: 0
      //     });
      //   }

      //   // Animate clones
      //   const animate = () => {
      //     let allDone = true;
      //     clones.forEach(cloneObj => {
      //       cloneObj.distance += cloneObj.speed;
      //       const x = Math.cos(cloneObj.angle) * cloneObj.distance;
      //       const y = Math.sin(cloneObj.angle) * cloneObj.distance;

      //       cloneObj.element.style.transform = `translate(${x}px, ${y}px)`;
      //       if (cloneObj.distance < 1200) allDone = false; // Keep animating until far enough
      //     });

      //     if (!allDone) requestAnimationFrame(animate);
      //     else {
      //       clones.forEach(cloneObj => {
      //         // cloneObj.element.style.opacity = "0";
      //         cloneObj.element.remove();
      //       });
      //     }
      //   };

      //   animate();
      // },

      (img) => {
        // Burst animation
        const clones = [];
        let allDone;
        const cloneContainer = document.createElement("div");
        cloneContainer.classList.add("clone-container");
        cloneContainer.style.position = "absolute";
        cloneContainer.style.top = "0";
        cloneContainer.style.left = "0";
        cloneContainer.style.width = "100%";
        cloneContainer.style.height = "100%";
        cloneContainer.style.pointerEvents = "none";
        // cloneContainer.style.zIndex = "100"
        img.parentElement.appendChild(cloneContainer);

        for (let i = 0; i < 5; i++) {
          const clone = img.cloneNode(true);
          clone.style.position = "absolute";
          clone.style.zIndex = "1000";
          clone.style.left = img.offsetLeft + "px";
          clone.style.top = img.offsetTop + "px";
          clone.style.width = img.offsetWidth + "px";
          clone.style.height = img.offsetHeight + "px";
          // clone.style.transition = "opacity 0.5s ease-out";
          clone.style.pointerEvents = "none";
          cloneContainer.appendChild(clone);
          clones.push({
            element: clone,
            angle: (Math.PI * 2 * i) / 5, // Spread clones in different directions
            speed: Math.random() * 1 + 10, // Random speed
            distance: 0,
          });
        }

        // Animate clones
        const animate = () => {
          allDone = true;
          clones.forEach((cloneObj) => {
            cloneObj.distance += cloneObj.speed;
            const x = Math.cos(cloneObj.angle) * cloneObj.distance;
            const y = Math.sin(cloneObj.angle) * cloneObj.distance;

            cloneObj.element.style.transform = `translate(${x}px, ${y}px)`;
            if (cloneObj.distance < 1200) allDone = false; // Keep animating until far enough
          });

          if (!allDone) requestAnimationFrame(animate);
          else {
            clones.forEach((cloneObj) => {
              // cloneObj.element.style.opacity = "0";
              cloneObj.element.remove();
            });
          }
        };

        product.addEventListener("mouseleave", () => {
          // cloning = false;
          // cancelAnimationFrame(frame);
          // clones.forEach(clone => clone.remove());
          clones.forEach((cloneObj) => {
            // cloneObj.element.style.opacity = "0";
            cloneObj.element.remove();
          });
        });

        animate();
      },

      // (img) => {
      //   // Trailing Copies Animation
      //   let direction = Math.random() * Math.PI * 2; // Random angle in radians
      //   let offsetX = Math.cos(direction) * 30; // X movement per clone
      //   let offsetY = Math.sin(direction) * 30; // Y movement per clone
      //   let cloning = true;
      //   let frame;
      //   let cloneCount = 0;
      //   let frameCounter = 0;
      //   const clones = [];
      //   const shrinkFactor = 0.9; // Each clone is 90% the size of the previous one

      //   const createClone = () => {
      //     if (cloning && cloneCount < 50) {
      //       frameCounter++;
      //       if (frameCounter % 2 === 0) {
      //         const clone = img.cloneNode(true);
      //         clone.style.position = "absolute";
      //         clone.style.pointerEvents = "none";
      //         clone.style.zIndex = "50";

      //         // Calculate the new size based on the shrink factor
      //         const scale = Math.pow(shrinkFactor, cloneCount);
      //         const newWidth = img.offsetWidth * scale;
      //         const newHeight = img.offsetHeight * scale;

      //         // Position the clone
      //         clone.style.left = img.offsetLeft + offsetX * cloneCount + "px";
      //         clone.style.top = img.offsetTop + offsetY * cloneCount + "px";
      //         clone.style.width = newWidth + "px";
      //         clone.style.height = newHeight + "px";

      //         img.parentElement.appendChild(clone);
      //         clones.push(clone);
      //         cloneCount++;
      //       }

      //       frame = requestAnimationFrame(createClone);
      //     }
      //   };

      //   product.addEventListener("mouseleave", () => {
      //     cloning = false;
      //     cancelAnimationFrame(frame);
      //     clones.forEach((clone) => clone.remove());
      //   });

      //   product.addEventListener("blur", () => {
      //     cloning = false;
      //     cancelAnimationFrame(frame);
      //     clones.forEach((clone) => clone.remove());
      //   });

      //   createClone();
      // },

      // (img) => {
      //   // Shrinking Size Animation
      //   let direction = Math.random() * Math.PI * 2; // Random angle in radians
      //   let offsetX = Math.cos(direction) * 30; // X movement per clone
      //   let offsetY = Math.sin(direction) * 30; // Y movement per clone
      //   let cloning = true;
      //   let frame;
      //   let cloneCount = 0;
      //   let frameCounter = 0;
      //   const clones = [];
      //   const shrinkFactor = 0.9; // Each clone is 90% the size of the previous one

      //   const createClone = () => {
      //     if (cloning && cloneCount < 50) {
      //       frameCounter++;
      //       if (frameCounter % 6 === 0) {
      //         const clone = img.cloneNode(true);
      //         clone.style.position = "absolute";
      //         clone.style.pointerEvents = "none";
      //         clone.style.zIndex = "50";

      //         // Calculate the new size based on the shrink factor
      //         const scale = Math.pow(shrinkFactor, cloneCount);
      //         const newWidth = img.offsetWidth * scale;
      //         const newHeight = img.offsetHeight * scale;

      //         // Calculate centered position
      //         const offsetX =
      //           img.offsetLeft + img.offsetWidth / 2 - newWidth / 2;
      //         const offsetY =
      //           img.offsetTop + img.offsetHeight / 2 - newHeight / 2;
      //         clone.style.left = offsetX + "px";
      //         clone.style.top = offsetY + "px";
      //         clone.style.width = newWidth + "px";
      //         clone.style.height = newHeight + "px";

      //         img.parentElement.appendChild(clone);
      //         clones.push(clone);
      //         cloneCount++;
      //       }

      //       frame = requestAnimationFrame(createClone);
      //     }
      //   };

      //   product.addEventListener("mouseleave", () => {
      //     cloning = false;
      //     cancelAnimationFrame(frame);
      //     clones.forEach((clone) => clone.remove());
      //   });

      //   product.addEventListener("blur", () => {
      //     cloning = false;
      //     cancelAnimationFrame(frame);
      //     clones.forEach((clone) => clone.remove());
      //   });

      //   createClone();
      // },

			// (img) => {
			// 	// growing layers 
			// 	let direction = Math.random() * Math.PI * 2; // Random angle in radians
			// 	let offsetX = Math.cos(direction) * 30; // X movement per clone
			// 	let offsetY = Math.sin(direction) * 30; // Y movement per clone
			// 	let cloning = true;
			// 	let frame;
			// 	let cloneCount = 0;
			// 	let frameCounter = 0;
			// 	const clones = [];
			// 	const scaleIncrement = 1.1; // Jump in scale by 10%
				
			// 	const createClone = () => {
			// 		if (cloning && cloneCount < 50) {
			// 			frameCounter++;
			// 			if (frameCounter % 6 === 2) {
			// 				if (clones.length < 30) {
			// 					const clone = img.cloneNode(true);
			// 					clone.style.position = "absolute";
			// 					clone.style.pointerEvents = "none";
			// 					clone.style.zIndex = "50";
			// 					clone.style.left = img.offsetLeft + "px";
			// 					clone.style.top = img.offsetTop + "px";
			// 					clone.style.width = img.offsetWidth + "px";
			// 					clone.style.height = img.offsetHeight + "px";
			// 					clone.style.objectFit = "none"; // Prevents CSS scaling
			// 					// clone.style.aspectRatio = 1 / 1; // Ensures the image maintains its native ratio
			// 					clone.style.flexShrink = "0"; // Prevents shrinking in flexbox
			// 					clone.style.maxWidth = "none";
			// 					clone.style.maxHeight = "none";
					
			// 					img.parentElement.appendChild(clone);
			// 					clones.push(clone);
			// 					cloneCount++;
					
			// 					// Scale up all existing clones by 10%
			// 					clones.forEach((clone) => {
			// 						const currentWidth = parseFloat(clone.style.width);
			// 						const currentHeight = parseFloat(clone.style.height);
			// 						clone.style.width = currentWidth * scaleIncrement + "px";
			// 						clone.style.height = currentHeight * scaleIncrement + "px";
			// 						clone.style.left = parseFloat(clone.style.left) - (currentWidth * (scaleIncrement - 1)) / 2 + "px";
			// 						clone.style.top = parseFloat(clone.style.top) - (currentHeight * (scaleIncrement - 1)) / 2 + "px";
			// 					});
			// 				}
			// 			}
				
			// 			frame = requestAnimationFrame(createClone);
			// 		}
			// 	};
				
			// 	product.addEventListener("mouseleave", () => {
			// 		cloning = false;
			// 		cancelAnimationFrame(frame);
			// 		clones.forEach((clone) => clone.remove());
			// 	});
				
			// 	product.addEventListener("blur", () => {
			// 		cloning = false;
			// 		cancelAnimationFrame(frame);
			// 		clones.forEach((clone) => clone.remove());
			// 	});
				
			// 	createClone();
				

			// },

      // (img) => {
      //   // STACKING
      //   let cloning = true;
      //   let frame;
      //   let cloneCount = 0;
      //   let frameCounter = 0;
      //   const clones = [];

      //   const createClone = () => {
      //     if (cloning && cloneCount < 50) {
      //       frameCounter++;
      //       if (frameCounter % 20 === 0) {
      //         const clone = img.cloneNode(true);
      //         clone.style.position = "absolute";
      //         clone.style.pointerEvents = "none";
      //         clone.style.zIndex = "50";

      //         // Calculate centered position
      //         const offsetX = img.offsetLeft + Math.random() * 2 - 1;
      //         const offsetY = img.offsetTop + Math.random() * 2 - 1;
      //         clone.style.transform = `scale(${Math.random() * 0.2 + 1})`;
      //         clone.style.left = offsetX + "em";
      //         clone.style.top = offsetY + "em";

      //         img.parentElement.appendChild(clone);
      //         clones.push(clone);
      //         cloneCount++;
      //       }

      //       frame = requestAnimationFrame(createClone);
      //     }
      //   };

      //   product.addEventListener("mouseleave", () => {
      //     cloning = false;
      //     cancelAnimationFrame(frame);
      //     clones.forEach((clone) => clone.remove());
      //   });

      //   product.addEventListener("blur", () => {
      //     cloning = false;
      //     cancelAnimationFrame(frame);
      //     clones.forEach((clone) => clone.remove());
      //   });

      //   createClone();
      // },

      (img) => {
        // Random placement throughout the page
        let cloning = true;
        let frame;
        let cloneCount = 0;
        let frameCounter = 0;
        const clones = [];
        img.parentElement.style.position = "relative";

        const createClone = () => {
          if (cloning) {
            frameCounter++;
            if (frameCounter % 20 === 2) {
              const clone = img.cloneNode(true);
              clone.style.position = "absolute";
              clone.style.pointerEvents = "none";
              clone.style.zIndex = "50";
              const rect = img.getBoundingClientRect();

              // **Ensure consistent width & height**
              // let sizeMultiplier = Math.random() * 0.6 + 0.6;
              let sizeMultiplier = 1
              clone.style.width = img.offsetWidth * sizeMultiplier + "px";
              clone.style.height = img.offsetHeight * sizeMultiplier + "px";

              // **Centering fix**
              // clone.style.transform = "translate(-50%, -50%)";
              let posMultiplier = .7;
              clone.style.left =
                Math.random() * rect.width * posMultiplier -
                (rect.width / 2) * posMultiplier +
                "px";
              clone.style.top =
                Math.random() * rect.width * posMultiplier * 0.8 -
                (rect.width / 2) * posMultiplier +
                "px";

              img.parentElement.appendChild(clone);
              clones.push(clone);
              cloneCount++;
            }

            frame = requestAnimationFrame(createClone);
          }
        };

        product.addEventListener("mouseleave", () => {
          cloning = false;
          cancelAnimationFrame(frame);
          clones.forEach((clone) => clone.remove());
        });

        product.addEventListener("blur", () => {
          cloning = false;
          cancelAnimationFrame(frame);
          clones.forEach((clone) => clone.remove());
        });

        createClone();
      },

      // (img) => {
      //   // Store the original image sources to revert them later

      //   let mainImage = img.querySelector("img");
      //   console.log(mainImage);
      //   let allImages = document.querySelectorAll(".grid__image img");
      //   let clones = [];

      //   // Function to change all images to the hovered image's src
      //   const changeImages = (mainImage) => {
      //     console.log("Cloning and overlaying:", mainImage.src);

      //     // Hide all images
      //     allImages.forEach((image) => {
      //       image.style.opacity = "0";
      //       const clone = mainImage.cloneNode(true);
      //       clone.style.position = "absolute";
      //       clone.style.top = `${image.offsetTop}px`;
      //       clone.style.left = `${image.offsetLeft}px`;
      //       clone.style.width = `${image.offsetWidth}px`;
      //       clone.style.height = `${image.offsetHeight}px`;
      //       clone.style.pointerEvents = "none";
      //       clone.style.zIndex = "1000";
      //       clone.style.opacity = "1";
      //       clone.classList.add("image-overlay-clone");

      //       image.parentElement.appendChild(clone);
      //       clones.push(clone);
      //     });
      //   };

      //   // Restore images and remove clones on mouse leave or blur
      //   const restoreImages = () => {
      //     console.log("Restoring original images");
      //     allImages.forEach((image) => {
      //       image.style.opacity = "1";
      //     });

      //     clones.forEach((clone) => clone.remove());
      //   };

      //   // Event listeners to trigger change and restore

      //   product.addEventListener("mouseleave", restoreImages);
      //   product.addEventListener("blur", restoreImages);

      //   changeImages(mainImage);
      // },

      (img) => {
        // DVD Screensaver Animation
        let vx = (Math.random() > 0.5 ? 1 : -1) * (Math.random() * 3 + 3); // Random X velocity
        let vy = (Math.random() > 0.5 ? 1 : -1) * (Math.random() * 3 + 3); // Random Y velocity
        let bouncing = true;
        let frame;

        // Hide the original image
        img.style.opacity = "0";

        // Get original image position
        const rect = img.getBoundingClientRect();

        // Create the bouncing clone
        const clone = img.cloneNode(true);
        document.body.appendChild(clone);

        // Set clone styles
        clone.style.position = "fixed"; // Moves independently of scrolling
        clone.style.left = `${rect.left}px`;
        clone.style.top = `${rect.top}px`;
        clone.style.width = `${rect.width}px`;
        clone.style.height = `${rect.height}px`;
        clone.style.zIndex = "1000";
        clone.style.pointerEvents = "none"; // Prevent interactions
        clone.style.opacity = "1"; // Ensure it's visible
        clone.style.display = "block"; // Ensure it's displayed

        let x = rect.left;
        let y = rect.top;

        // console.log("Clone created at:", x, y);

        const bounce = () => {
          if (!bouncing) return;

          // Get viewport dimensions
          const vw = window.innerWidth;
          const vh = window.innerHeight;
          const cloneWidth = clone.offsetWidth;
          const cloneHeight = clone.offsetHeight;

          // Update position
          x += vx;
          y += vy;

          // Bounce off viewport edges
          if (x <= 0 || x + cloneWidth >= vw) {
            vx *= -1;
            x = Math.max(0, Math.min(x, vw - cloneWidth));
          }
          if (y <= 0 || y + cloneHeight >= vh) {
            vy *= -1;
            y = Math.max(0, Math.min(y, vh - cloneHeight));
          }

          // Apply new position
          clone.style.left = `${x}px`;
          clone.style.top = `${y}px`;

          // console.log("Clone moved to:", x, y);

          frame = requestAnimationFrame(bounce);
        };

        product.addEventListener("mouseleave", () => {
          bouncing = false;
          cancelAnimationFrame(frame);
          clone.remove();
          img.style.opacity = "1"; // Restore original image
        });

        product.addEventListener("blur", () => {
          bouncing = false;
          cancelAnimationFrame(frame);
          clone.remove();
          img.style.opacity = "1"; // Restore original image
        });

        bounce();
      },

      (img) => {
        // Perspective Dance

        // Ensure the parent has perspective
        const parent = img.parentElement;
        parent.style.perspective = "8cm"; // Apply perspective to the parent container
        parent.style.perspectiveOrigin = "50% 50%"; // Center the effect

        // Check if a wrapper already exists, otherwise create it
        let wrapper = img.closest(".perspective-wrapper");
        if (!wrapper) {
          wrapper = document.createElement("div");
          wrapper.classList.add("perspective-wrapper");
          wrapper.style.display = "block";
          wrapper.style.transformStyle = "preserve-3d"; // Ensures 3D effect
          wrapper.style.width = img.offsetWidth + "px";
          wrapper.style.height = img.offsetHeight + "px";
          img.style.zIndex = "1000";
          img.style.position = "relative";

          // Move the image inside the wrapper
          img.parentElement.insertBefore(wrapper, img);
          wrapper.appendChild(img);
        }

        // Define the CSS animation if it doesn't exist yet
        const animationName = "perspectiveRotateAnim";
        if (!document.getElementById(animationName)) {
          const style = document.createElement("style");
          style.id = animationName;
          style.textContent = `
            @keyframes ${animationName} {
              0%   { transform: rotateX(0deg) rotateY(0deg) rotateZ(0deg) scale(.9); }
              25%  { transform: rotateX(-25deg) rotateY(-20deg) rotateZ(-10deg) scale(.9); }
              50%  { transform: rotateX(0deg) rotateY(0deg) rotateZ(0deg) scale(.9); }
              75%  { transform: rotateX(-25deg) rotateY(20deg) rotateZ(10deg) scale(.9); }
              100% { transform: rotateX(0deg) rotateY(0deg) rotateZ(0deg) scale(.9); }
            }
          `;
          document.head.appendChild(style);
        }

        // Apply animation when hovered
        wrapper.style.animation = `${animationName} 0.7s infinite linear`;

        product.addEventListener("mouseleave", () => {
          wrapper.style.animation = ""; // Stop animation when hover ends
          img.style.zIndex = "1";
        });

        product.addEventListener("blur", () => {
          wrapper.style.animation = ""; // Stop animation when hover ends
          img.style.zIndex = "1";
        });
      },

      (img) => {
        // Stretch Dance #1
        // Ensure the image is set up for transformations
        img.style.display = "block"; // Prevents unwanted scaling issues
        img.style.transformOrigin = "center"; // Ensures squishing happens symmetrically
        img.style.zIndex = "1000";
        img.style.position = "relative";

        // Define the CSS animation if it doesn't exist yet
        const animationName = "squishAnim";
        if (!document.getElementById(animationName)) {
          const style = document.createElement("style");
          style.id = animationName;
          // style.textContent = `
          //   @keyframes ${animationName} {
          //     0%   { transform: scaleX(1) scaleY(1); }
          //     25%  { transform: scaleX(1.3) scaleY(0.7); } /* Squish horizontally */
          //     50%  { transform: scaleX(1) scaleY(1); }    /* Back to normal */
          //     75%  { transform: scaleX(0.7) scaleY(1.3); } /* Squish vertically */
          //     100% { transform: scaleX(1) scaleY(1); }    /* Back to normal */
          //   }
          // `;
          style.textContent = `
						@keyframes ${animationName} {
							0%   { transform: scaleX(1) scaleY(1); animation-timing-function: ease-in; }
							12.5%  { transform: scaleX(2) scaleY(1); animation-timing-function: ease-out; }
							25%  { transform: scaleX(1) scaleY(1); animation-timing-function: ease-in; }
							50%  { transform: scaleX(1) scaleY(1); animation-timing-function: ease-in; }
							62.5%  { transform: scaleX(1) scaleY(2); animation-timing-function: ease-out; }
							75%  { transform: scaleX(1) scaleY(1); animation-timing-function: ease-in; }
							100% { transform: scaleX(1) scaleY(1); animation-timing-function: ease-in;}
						}
					`;
					img.style.animation = `${animationName} 1.8s infinite linear`;
					// style.textContent = `
					// @keyframes ${animationName} {
          //      0%   { transform: scaleX(1) scaleY(1); }
          //      20%  { transform: scaleX(1.3) scaleY(0.7); } /* Squish horizontally */
          //      35%   { transform: scaleX(1) scaleY(1); }
          //      50%  { transform: scaleX(0.7) scaleY(1.3); } /* Squish vertically */
          //      70% { transform: scaleX(1) scaleY(1); }    /* Back to normal */
					// 	}
					// `;
          document.head.appendChild(style);
        }

        // Apply animation when hovered
        img.style.animation = `${animationName} 1.8s infinite linear`;

        console.log(animationName);

        product.addEventListener("mouseleave", () => {
          img.style.animation = ""; // Stop animation when hover ends
          img.style.zIndex = "1";
        });

        product.addEventListener("blur", () => {
          img.style.animation = ""; // Stop animation when hover ends
          img.style.zIndex = "1";
        });
      },


      (img) => {
        // Stretch Dance #2
        // Ensure the image is set up for transformations
        img.style.display = "block"; // Prevents unwanted scaling issues
        img.style.transformOrigin = "center"; // Ensures squishing happens symmetrically
        img.style.zIndex = "1000";
        img.style.position = "relative";

        // Define the CSS animation if it doesn't exist yet
        const animationName = "squishAnim_2";
        if (!document.getElementById(animationName)) {
          const style = document.createElement("style");
          style.id = animationName;
          // style.textContent = `
          //   @keyframes ${animationName} {
          //     0%   { transform: scaleX(1) scaleY(1); }
          //     25%  { transform: scaleX(1.3) scaleY(0.7); } /* Squish horizontally */
          //     50%  { transform: scaleX(1) scaleY(1); }    /* Back to normal */
          //     75%  { transform: scaleX(0.7) scaleY(1.3); } /* Squish vertically */
          //     100% { transform: scaleX(1) scaleY(1); }    /* Back to normal */
          //   }
          // `;
          // style.textContent = `
					// 	@keyframes ${animationName} {
					// 		0%   { transform: scaleX(1) scaleY(1); animation-timing-function: ease-in; }
					// 		12.5%  { transform: scaleX(1.5) scaleY(1); animation-timing-function: ease-out; }
					// 		25%  { transform: scaleX(1) scaleY(1); animation-timing-function: ease-in; }
					// 		50%  { transform: scaleX(1) scaleY(1); animation-timing-function: ease-in; }
					// 		62.5%  { transform: scaleX(1) scaleY(1.5); animation-timing-function: ease-out; }
					// 		75%  { transform: scaleX(1) scaleY(1); animation-timing-function: ease-in; }
					// 		100% { transform: scaleX(1) scaleY(1); animation-timing-function: ease-in;}
					// 	}
					// `;
					style.textContent = `
						@keyframes ${animationName} {
							0%   { transform: scaleX(1) scaleY(1); }
							25%  { transform: scaleX(1.3) scaleY(0.7); }
							50%  { transform: scaleX(1) scaleY(1); }
							75%  { transform: scaleX(0.7) scaleY(1.3); }
							100% { transform: scaleX(1) scaleY(1); }
						}
					`;
          document.head.appendChild(style);
        }

        // Apply animation when hovered
        img.style.animation = `${animationName} .7s infinite linear`;

        console.log(animationName);

        product.addEventListener("mouseleave", () => {
          img.style.animation = ""; // Stop animation when hover ends
          img.style.zIndex = "1";
        });

        product.addEventListener("blur", () => {
          img.style.animation = ""; // Stop animation when hover ends
          img.style.zIndex = "1";
        });
      },

      (img) => {
        // slot machine animation
        let offset = 0;
        let moving = true;
        let frame;

        const card = img.closest(".indiv-product");
        card.style.overflow = "hidden";

        const imgHeight = img.offsetHeight;
        const cardHeight = card.offsetHeight;
        const totalDist = 3 * (imgHeight + cardHeight);
        const duration = 2000;
        // const duration = 2000 + Math.random() * 700;
        const startTime = performance.now();

        const easeOut = (t) => 1 - Math.pow(1 - t, 4);

        const slotMachine = (currentTime) => {
          if (moving) {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const easedProgress = easeOut(progress);

            offset = easedProgress * totalDist;

            offset =
              -1 *
              (((offset + cardHeight) % (imgHeight + cardHeight)) - cardHeight);

            img.style.transform = `translateY(${offset}px)`;

            if (progress < 1) {
              frame = requestAnimationFrame(slotMachine);
            } else {
              moving = false;
              cancelAnimationFrame(frame);
              img.style.transform = "";
              card.style.overflow = "";
            }
          }
        };

        product.addEventListener("mouseleave", () => {
          moving = false;
          cancelAnimationFrame(frame);
          img.style.transform = "";
          img.style.zIndex = "1";
          card.style.overflow = "";
        });

        product.addEventListener("blur", () => {
          moving = false;
          cancelAnimationFrame(frame);
          img.style.transform = "scale(1)";
          img.style.zIndex = "1";
        });

        frame = requestAnimationFrame(slotMachine);
      },
    ];


		function normalZoom(img) {
			img.style.transition = "transform 300ms ease";
			img.style.transform = "scale(1.03)";
		
			const reset = () => {
				img.style.transform = "scale(1)";
				img.addEventListener(
					"transitionend",
					() => {
						img.style.transition = "";
					},
					{ once: true }
				);
			};
		
			img.closest(".indiv-product").addEventListener("mouseleave", reset);
			img.closest(".indiv-product").addEventListener("blur", reset);
		}

    let toggleState = 0; // 0, 1, or 2
    let randomThreshold = 0.4; // Default value
    let option3 = false;

    const gridItems = document.querySelectorAll(".indiv-product");
    gridItems.forEach((item) => item.classList.remove("hoverable"));
    // console.log(gridItems, "GRID ITEMS");
    // console.log("Mode 0: Removed 'hoverable' class, Random Threshold is 0.5");

    // document.addEventListener("keydown", (event) => {
    //   if (event.key.toLowerCase() === "c") {
    //     toggleState = (toggleState + 1) % 4; // Cycle through 0 → 1 → 2 → 0

    //     switch (toggleState) {
    //       case 0:
    //         option3 = false;
    //         // Option 1: Add "hoverable" class to all grid__item elements
    //         gridItems.forEach((item) => item.classList.remove("hoverable"));
    //         console.log(gridItems, "GRID ITEMS");
    //         randomThreshold = 0.5;

    //         console.log(
    //           "Mode 0: Removed 'hoverable' class, Random Threshold is 0.5"
    //         );
    //         break;

    //       case 1:
    //         option3 = false;
    //         // Option 3: Remove "hoverable" class but keep Math.random() < 0.5
    //         gridItems.forEach((item) => item.classList.add("hoverable"));
    //         randomThreshold = 0.5;
    //         console.log(
    //           "Mode 1: Added 'hoverable' class, Random Threshold is 0.5"
    //         );

    //         break;

    //       case 2:
    //         // Option 3: Remove "hoverable" class but keep Math.random() < 0.5
    //         gridItems.forEach((item) => item.classList.remove("hoverable"));
    //         randomThreshold = 0.5;
    //         option3 = true;
    //         console.log(
    //           "Mode 2: Added 'hoverable' class, Random Threshold is 0.5"
    //         );

    //         break;

    //       case 3:
    //         option3 = false;
    //         // Option 2: Remove "hoverable" class & set Math.random() < 0
    //         gridItems.forEach((item) => item.classList.remove("hoverable"));
    //         randomThreshold = 0;
    //         console.log(
    //           "Mode 3: Removed 'hoverable' class, Random Threshold is 0"
    //         );

    //         break;
    //     }
    //   }
    // });

    product.addEventListener("mouseenter", () => {
      // images.forEach(images => {
      // if (Math.random()<randomThreshold){
      //   if (option3){
      //     images.closest(".indiv-product").style.transform = `translateY(-0.4em)`;
      //   }
      // } else {
      // let randomAnimation = animations[Math.floor(Math.random() * animations.length)];
			let randomAnimation
			let count = 0
      if (Math.random()<randomThreshold){
				do {
					randomAnimation = animations[Math.floor(Math.random() * animations.length)];
					// randomAnimation = animations[3];
					count ++
					if (count > 10) randomAnimation = animations[0]
				}
				while ((randomAnimation == animations[6] || randomAnimation == animations[7]) && preventDistortion)
				// maybes: 4 (grow over time, decrease angle(referring to 3))
				// make them a ps template for cropping pngs
				randomAnimation(productImage);
				// }
				// });
			}
			else normalZoom(productImage);
    });
    product.addEventListener("mouseleave", () => {
      product.closest(".indiv-product").style.transform = `translateY(-0em)`;
    });
    product.addEventListener("blur", () => {
      product.closest(".grid__item").style.transform = `translateY(-0em)`;
    });
  });
}, 400);


}
